import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AppError } from '@core/api';

export type NotificationType = 'error' | 'warning' | 'info';

@Component({
  selector: 'la-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatTooltipModule],
})
export class NotificationComponent {
  @Input() type: NotificationType = 'info';
  @Input() message = '';
  @Input() tooltip = '';
  @Input() tooltipDisabled = false;
  @Input({ transform: booleanAttribute }) inline?: boolean;
  @Input() error?: AppError;
  @Input() title?: string;
}
